import AlertCircleOutlineIcon from 'mdi-react/AlertCircleOutlineIcon';
import CheckCircleOutlineIcon from 'mdi-react/CheckCircleOutlineIcon';
import ClockOutlineIcon from 'mdi-react/ClockOutlineIcon';
import TimerSandIcon from 'mdi-react/TimerSandIcon';

import type { StatusStyle, StatusVariant } from './types';

const STATUS_VARIANTS: Record<StatusVariant, StatusStyle> = {
  processing: {
    bg: 'yellow.200',
    borderColor: 'yellow.700',
    color: 'gray.900',
    icon: TimerSandIcon,
    iconColor: 'gray.900',
  },
  waiting: {
    bg: 'gray.50',
    borderColor: 'gray.100',
    color: 'gray.900',
    icon: ClockOutlineIcon,
    iconColor: 'gray.900',
  },
  success: {
    bg: 'green.500',
    borderColor: 'green.600',
    color: 'white',
    icon: CheckCircleOutlineIcon,
    iconColor: 'white',
  },
  error: {
    bg: 'siengeRed.500',
    borderColor: 'siengeRed.600',
    color: 'white',
    icon: AlertCircleOutlineIcon,
    iconColor: 'white',
  },
};

export default STATUS_VARIANTS;
